module.exports = __webpack_public_path__ + "static/media/img.0c822a9e.gif";